import React, { useState } from 'react';
import './Fittinginjctio.css';
import Fittinginjec1 from '../../../imgs/Fittinginjec1.webp';
import Fittinginjec2 from '../../../imgs/Fittinginjec2.webp';
import Fittinginjec3 from '../../../imgs/Fittinginjec3.webp';
import Fittinginjec4 from '../../../imgs/Fittinginjec4.webp';
import Reqprodcte from "../../../components/Reqprodcte";


const images = [
    { src: Fittinginjec1 },
    { src: Fittinginjec2 },
    { src: Fittinginjec3 },
    { src: Fittinginjec4 },
];

const Fittinginjctio = () => {
    const [current, setCurrent] = useState(0);

    const nextSlide = () => {
        setCurrent((current + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrent((current - 1 + images.length) % images.length);
    };

    const goToSlide = (index) => {
        setCurrent(index);
    };

    return (
        <div className="fittinginj-main-container">
        
            <div className="fittinginj-slideshow">
                {images.map((img, index) => (
                    <div className={index === current ? "mySlides active" : "mySlides"} data-aos="fade-down" key={index}>
                        {index === current && (
                            <>
                                <img src={img.src} alt={`Slide ${index + 1}`} className="slide-image"/>
                            </>
                        )}
                    </div>
                ))}
                <a className="prev" onClick={prevSlide}>&#10094;</a>
                <a className="next" onClick={nextSlide}>&#10095;</a>

                <div className="dots">
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={index === current ? "dot active" : "dot"}
                            onClick={() => goToSlide(index)}
                        ></span>
                    ))}
                </div>
            </div>

            <div className="fittinginj-text">
                <h2>PVC Fitting Injection Molding Machine</h2>
                <h3>PVC SERIES</h3>
                <p>
                   Powerjet new type PVC fitting injection molding machine are specialized for different sizes of PVC fitting. Saving 30%~50% of energy by using servo motor and more device options are available to fulfill customer requirements.
                </p>
                <ul>
                    <li><strong>Clamping Force:</strong> – 90~680(Ton)</li>
                    <li><strong>Applications :</strong> - PVC Fitting</li>
                   
                    <li><strong>Shooting Weight(PS)-</strong> 179~2847(g)</li>
                </ul>
                 <div className='stnd'>
                    <Reqprodcte />
                </div>
            </div>
        </div>
    );
};

export default Fittinginjctio;
